import { getMicroserviceBaseContext } from '../../constants/api-routing';

const adminContext = getMicroserviceBaseContext('admin');

export const ADMIN_SERVICE = {
    systemPrompt: `${adminContext}llm-system-prompt/module`,
    productDataSource: `${adminContext}get_sharepoint_by_business_unit_code/`,
    datasourceCode: `${adminContext}get_business_unit_datasource_by_bu_code/`,
    getDashboardTraineeSummary: `${adminContext}dashboard_get_user_summary`,
    getDashboardRoleplays: `${adminContext}dashboard_get_logged_in_users_count`,
    getDashboardAvatarcount: `${adminContext}dashboard_get_avatar_daily_score`,
    getDashboardAvatarbyDate: `${adminContext}dashboard_get_avatar_daily_score_with_timeframe`,
    getDashboardDailyscore: `${adminContext}dashboard_get_daily_score`,
    getDashboardDailyscoreByDate: `${adminContext}dashboard_get_daily_score_with_timeframe`,
    getMenuDetails: `${adminContext}menu_list/`,
    getCustomizeDetails: `${adminContext}llm_configuration_list`,
    getCustomizeDetailsByProductCode: `${adminContext}get_llm_configuration_by_business_unit_code`,
    createCustomizeDetails: `${adminContext}update_llm_configuration`,
    lastloginDetails: `${adminContext}update_last_login`,
    user_request: `${adminContext}request_access_sop`,
    ProductList: `${adminContext}get_business_unit_metadata`,
    profileImage: `/ai-advisor-storage/getblobmetadata`,
    getJobSchedulerList: `${adminContext}get_job_scheduler_list/`,
    getPromptData: `${adminContext}llm-system-prompt`,
    createUpdatePromptData: `${adminContext}llm-system-prompt`,
    resetPromptData: `${adminContext}llm-system-prompt/reset`,
    getPromptVersionList: `${adminContext}llm-system-prompt-versions`,
    getSystemPromptByVersion: `${adminContext}llm-system-prompt/`,
    getApplicationFeedbackList: `${adminContext}app-feedback/business-unit`,
    getApplicationFeedback: `${adminContext}app-feedback`,
    saveApplicationFeedbackList: `${adminContext}app-feedback`,
    updateApplicationFeedbackList: `${adminContext}app-feedback`,
    deleteApplicationFeedback: `${adminContext}app-feedback`,
    getKeyVaultByCode: `${adminContext}get_vault_mapping_by_business_unit_code/`,
    getDataSorceList: `${adminContext}list_sharepoint_paths`,
    referenceFilePath: `${adminContext}business-unit-metadata/code`,
    getRegionList: `${adminContext}list_primary_regions`,
    getMarketList: `${adminContext}list_primary_market_with_region`,
    getDetailMarketList: `${adminContext}detail_list_primary_market_with_region`,
    getProductMetaData: `${adminContext}get_business_unit_product_metadata`,
    getQuestionList: `${adminContext}business-faq/business-unit`,
    createQuestion: `${adminContext}business-faq`,
    changeStatus: `${adminContext}business-faq/status-change`,
    updateQuestion: `${adminContext}business-faq/`,
    create_schedule_outage: `${adminContext}create_schedule_outage`,
    update_schedule_outage: `${adminContext}update_schedule_outage/`,
    delete_schedule_outage: `${adminContext}delete_schedule_outage/`,
    schedule_outages_list: `${adminContext}schedule_outages_list`,
    schedule_outage: `${adminContext}schedule_outage`,
}
